import React, { useState, memo, useEffect } from "react";
import "./PricingAnalysis.css";
import { handlingCatchError } from "../../../../Utils/ErrorHandling";

import { useNavigate, useLocation } from "react-router-dom";
import ArrowUp from "@mui/icons-material/ArrowUpward";
import ArrowDown from "@mui/icons-material/ArrowDownward";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import InfiniteScroll from "react-infinite-scroller";
import PriceConversion from "../../PriceConversion/PriceConversion";
import { capitalizeFirstLetter } from "../../../../helpers/dataHelper";
import { apiCommonTrigger } from "../../../../Utils/apiServicehelper";
import { Config } from "../../../../Utils/Config";
let profileArray = [];
let priceArray = [];

const PricingAnalysis = memo((props) => {
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(25);
  const [orderDirection, setOrderDirection] = useState(true);
  const [totalPage, setTotalRecords] = useState(0);
  const [priceAnalysis, setPriceAnalysis] = useState([]);
  const [priceAvg, setPriceAvg] = useState([]);

  const marketId = props && props.marketId ? props.marketId : null;

  //call rvlist based on the below changes
  useEffect(() => {
    if(page === 1 || page <= totalPage){
    getPricingAnalysisData();}
  }, [page, orderDirection]);

  //call pricing analysis api
  const getPricingAnalysisData = async () => {
    setLoading(true);
    let inputData={marketId: marketId,
        page: page,
        resultsPerPage: rowsPerPage,
        orderBy: "profileName",
        orderDirection: orderDirection ? "Asc" : "Desc"}
    await apiCommonTrigger("post",`${Config.API_URL}/markets/market/analysis/price`,inputData).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        if (res.data.profileprices && res.data.profileprices.length > 0) {
          if(page === 1){
            profileArray = [];
            priceArray = [];
          }
          const result = res.data.profileprices.reduce(function (results, org) {
            (results[org.profilename+org.profileid] = results[org.profilename+org.profileid] || []).push(org);
            return results;
          }, {});
          profileArray.push(result);
          let filteredArray = Array.from(
            new Set(profileArray.map(JSON.stringify)),
            JSON.parse
          );
          setPriceAnalysis([]);
          setPriceAnalysis(filteredArray);
          setTotalRecords(res.data.pagination.totalpages);
        }
        if (res.data.priceaverages && res.data.priceaverages.length > 0) {
         
            const avg_priceResult =  res.data.priceaverages.reduce(function (results, org) {
              (results[org.profilename+org.profileid] = results[org.profilename+org.profileid] || []).push(org);
              return results;
            }, {});
            priceArray.push(avg_priceResult);
            let filteredPriceArray = Array.from(
              new Set(priceArray.map(JSON.stringify)),
              JSON.parse
           ); 
         
           setPriceAvg(filteredPriceArray);
        }
        else {
           setPriceAnalysis([]);
           setPriceAvg([]);
        }
      } else{
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  // call lazyloading
  const handleInfiniteOnLoad = () => { setPage(page + 1) };

  return (
    <div>
      {isLoading ? (
        <div className="loader-wrap">
          <div className="loading loading-center"></div>
        </div>
      ) : (
        ""
      )}
      <div className="season-table table-height price-analysis">
        <InfiniteScroll
          initialLoad={false}
          loadMore={handleInfiniteOnLoad}
          hasMore={page !== totalPage}
          threshold={20}
          useWindow={false}
        >
          <Table className="table-design">
            <TableHead>
              <TableRow>
                <TableCell id="sort-amenities" onClick={() => {
                      setOrderDirection(!orderDirection);
                      setPage(1);
                    }}>
                    Campgrounds {orderDirection ? <ArrowDown /> : <ArrowUp />}
                  </TableCell>
                <TableCell></TableCell>
                <TableCell>RV Lot</TableCell>
                <TableCell>Camping/Tent Lot</TableCell>
                <TableCell>Cabin</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {priceAvg && priceAvg.length > 0 ? (
                priceAvg.map((x) => {
                  let dt = Object.values(x);
                  return dt.map((data) => {
                    return (
                      <React.Fragment>
                        <TableRow key={capitalizeFirstLetter(data[0].priceper)}>
                          <TableCell
                            rowSpan={data.length}
                            className="profile-name"
                          >
                            Avg Market Price
                          </TableCell>
                          <TableCell>{capitalizeFirstLetter(data[0].priceper)}</TableCell>
                          <TableCell>
                            {data[0].averagervsite ? <PriceConversion price={data[0].averagervsite} symbol={"$"}/>  : "-"}
                          </TableCell>
                          <TableCell>
                            {data[0].averagetent ? <PriceConversion price={data[0].averagetent} symbol={"$"}/> : "-"}
                          </TableCell>
                          <TableCell>
                            {data[0].averagecabin ? <PriceConversion price={data[0].averagecabin} symbol={"$"}/> : "-"}
                          </TableCell>
                        </TableRow>
                        {data.length > 1 ? (
                          <TableRow key={capitalizeFirstLetter(data[1].priceper)}>
                            <TableCell>{capitalizeFirstLetter(data[1].priceper)}</TableCell>
                            <TableCell>
                              {data[1].averagervsite ? <PriceConversion price={data[1].averagervsite} symbol={"$"}/>  : "-"}
                            </TableCell>
                            <TableCell>
                              {data[1].averagetent ? <PriceConversion price={data[1].averagetent} symbol={"$"}/>  : "-"}
                            </TableCell>
                            <TableCell>
                              {data[1].averagecabin ? <PriceConversion price={data[1].averagecabin} symbol={"$"}/>  : "-"}
                            </TableCell>
                          </TableRow>
                        ) : null}
                        {data.length > 2 ? (
                          <TableRow key={capitalizeFirstLetter(data[2].priceper)}>
                            <TableCell>{capitalizeFirstLetter(data[2].priceper)}</TableCell>
                            <TableCell>
                              {data[2].averagervsite ? <PriceConversion price={data[2].averagervsite} symbol={"$"}/>  : "-"}
                            </TableCell>
                            <TableCell>
                              {data[2].averagetent ? <PriceConversion price={data[2].averagetent} symbol={"$"}/>  : "-"}
                            </TableCell>
                            <TableCell>
                              {data[2].averagecabin ? <PriceConversion price={data[2].averagecabin} symbol={"$"}/>  : "-"}
                            </TableCell>
                          </TableRow>
                        ) : null}
                       
                      </React.Fragment>
                    );
                  });
                })
              ) : null}

              {priceAnalysis && priceAnalysis.length > 0 ? (
                priceAnalysis.map((x) => {
                  let dt = Object.values(x);
                  return dt.map((data) => {
                    return (
                      <React.Fragment>
                        <TableRow key={data[0].profileid}>
                          <TableCell
                            rowSpan={data.length}
                            className="profile-name"
                          >
                            {data[0].profilename}
                          </TableCell>
                          <TableCell>{capitalizeFirstLetter(data[0].priceper)}</TableCell>
                          <TableCell>
                            {data[0].rvsite ? data[0].rvsite : "-"}
                          </TableCell>
                          <TableCell>
                            {data[0].tent ? data[0].tent : "-"}
                          </TableCell>
                          <TableCell>
                            {data[0].cabin ? data[0].cabin : "-"}
                          </TableCell>
                        </TableRow>
                        {data.length > 2 ? (
                          <TableRow key={data[2].profileid}>
                            <TableCell>{capitalizeFirstLetter(data[2].priceper)}</TableCell>
                            <TableCell>
                              {data[2].rvsite ? data[2].rvsite : "-"}
                            </TableCell>
                            <TableCell>
                              {data[2].tent ? data[2].tent : "-"}
                            </TableCell>
                            <TableCell>
                              {data[2].cabin ? data[2].cabin : "-"}
                            </TableCell>
                          </TableRow>
                        ) : null}
                        {data.length > 1 ? (
                          <TableRow key={data[1].profileid}>
                            <TableCell>{capitalizeFirstLetter(data[1].priceper)}</TableCell>
                            <TableCell>
                              {data[1].rvsite ? data[1].rvsite : "-"}
                            </TableCell>
                            <TableCell>
                              {data[1].tent ? data[1].tent : "-"}
                            </TableCell>
                            <TableCell>
                              {data[1].cabin ? data[1].cabin : "-"}
                            </TableCell>
                          </TableRow>
                        ) : null}
                      </React.Fragment>
                    );
                  });
                })
              ) : (
                <TableRow key="0">
                  <TableCell
                    colSpan={"5"}
                    style={{ textAlign: "center" }}
                    className="store-no-data"
                  >
                    {isLoading ? null : "No records found"}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </InfiniteScroll>
      </div>
    </div>
  );
});

export default PricingAnalysis;
